"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassGetter = void 0;
const bind_1 = __importDefault(require("classnames/bind"));
/**
 * Фабрика геттеров CSS-классов.
 * @param classes Классы из CSS-модуля.
 * @param isValidKey Функция проверки ключа для класса.
 * @param [prefix] Префикс имени класса.
 * @return Геттер CSS-класса.
 * @deprecated
 */
const ClassGetter = (classes, isValidKey, prefix = '') => {
    const cx = bind_1.default.bind(classes);
    return (value) => (isValidKey(value) ? cx(`${prefix}${value}`) : undefined);
};
exports.ClassGetter = ClassGetter;
//# sourceMappingURL=utils.js.map